import React, { useContext } from "react";
import { LanguageContext, text } from "../../../container/language";

const SectionHeader = ({ data }) => {
  const { userLanguage } = useContext(LanguageContext);
  const { subheaderAlignment } = data;
  return (
    <div className="text">
      <h4 style={{ textAlign: subheaderAlignment.toLowerCase() }}>
        <br />
        <font>
          <font>{text(data.text, userLanguage)}</font>
        </font>
      </h4>
    </div>
  );
};

export default SectionHeader;
